import Vue from 'vue';
import axios from 'axios';
import defaultUrl from './urls.js';
let _this = new Vue({});
// 创建axios
const _axios = axios.create({
    // baseURL: defaultUrl,
    timeout: 30000,
    withCredentials: false,
    headers: {
        // "X-Requested-With": "XMLHttpRequest"
        // "Origin": "https://wx.mvcsky.com",
        // "Access-Control-Allow-Origin": "https://wx.mvcsky.com",
        // "Access-Control-Allow-Headers": "X-Requested-With,Content-Type",
        // "Access-Control-Allow-Methods": "PUT,POST,GET,DELETE,OPTIONS",
        // "Access-Control-Allow-Credentials": true,
        // "Content-Type": "application/x-www-form-urlencoded"
        // "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    }
});
// _axios.defaults.transformRequest = [function (data) {
//     let ret = '';
//     for (let it in data) {
//       ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
//     }
//     return ret;
// }];
// 请求拦截器
_axios.interceptors.request.use(config => {
    let token = window.localStorage.getItem('token');
    config.headers.Authorization = token ? 'Bearer' + token : 'Bearer';
    return config;
}, error => {
    return Promise.reject(error);
});
// 响应拦截器
_axios.interceptors.response.use(response => {
    if(response.data.status >= 40100) {
        // 40100 token已过期, 40101 token无效, 40102 token被列入黑名单, 40103 未传递token
        // token无效，通知退出登录
        _this.$bus.$emit('logOut', true);
    }
    return response.data;
}, error => {
    return Promise.reject(error);
});
export default _axios;


// WEBPACK FOOTER //
// ./src/ws/domain.js